export default {
  IMAGE_SRC:
    'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8zw4AAgsBCBwSPhsAAAAASUVORK5CYII=',
  IMAGE_POSITION: '50% 50%',
  IMAGE_SCALE: '1',
  IFRAME_SRC: 'https://www.youtube.com/embed/hNQFjqDvPhA',
};
